import { Injectable, Inject } from '@angular/core';
import { PaymentMethod } from '../../model/payment-method';
import { DataService } from '../../../core/service/base/data.service';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SelectionItem } from '../../../core/component/select/select.component';
import { CompanyBankAccount } from '../../../rent/model/company-bank-account';
import { map } from 'rxjs/operators';

@Injectable()
export class PaymentMethodService extends DataService<PaymentMethod> {
  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, config, messageService, PaymentMethod, progressBar, 'payment-method');
  }

  getBankAccountSelection(companyId: string, nullSelectionText?: string): Observable<SelectionItem[]> {
    return this.client.get<CompanyBankAccount[]>(`${this.endpoint}/bank-accounts/${companyId}`).pipe(
      map(res => {
        let result = res.map(acc => new SelectionItem(acc.name, acc.id));
        if (nullSelectionText) {
          result.splice(0, 0, new SelectionItem(nullSelectionText, null));
        }
        return result;
      })
    );
  }
}
